@if (acl(); as currentAcl) {
  <era-pane>
    @if (currentAcl.groups) {
      <era-acl-group-list [routePrefix]="'groups/'"
                          [groups]="currentAcl.groups"></era-acl-group-list>
    }
    @if (currentAcl.users) {
      <era-acl-member-list [routePrefix]="'users/'"
                           [members]="currentAcl.users"></era-acl-member-list>
    }
  </era-pane>
}